import * as jose from 'jose';

export function isExpired(jwt: string): boolean {
    const exp = jose.decodeJwt(jwt).exp ?? 0;

    return Date.now() >= exp * 1000;
}
